import {
    serverBus
} from '@/main';
import SessionManager from '@/Manager/Session.manager'
import Global from '@/scripts/Global';
import VueSignals from '@/scripts/VueSignals';
import SoundMeter from '@/classes/SoundMeter'

export default {
    name: 'Conference',
    data() {
        return {
            loggedInUser: SessionManager.getLoggedInUser(),
            ConferenceUsers: [],
            BusyUsers: [],
            NotReacted: [],
            Declined: [],
            showConference: false,
            videoUsersIds: [],
            mutedAudioUsersIds: [],
            initUserId: '',
            right_sidebar_theme: '',
            mouseOverUserId: '',
            showRinging: true,
            isFullscreen: false,
            originalNode: null,
            inCall: false,
            CallChannel: null
        }
    },
    mounted() {
        this.ConferenceUsers = []
        this.BusyUsers = []
        this.NotReacted = []
        this.showRinging = true
        serverBus.$on(VueSignals.RIGHT_SIDEBAR_THEME, (theme) => {
            this.right_sidebar_theme = theme
        })

        serverBus.$on(VueSignals.LOGGED_IN_USER, () => {
            this.loggedInUser = SessionManager.getLoggedInUser()
        })

        serverBus.$on("CALL_INIT_USER_ID", (initUserId) => {
            this.initUserId = initUserId
        })

        serverBus.$on("RTC_Call", (status) => {
            this.inCall = status
        })

        serverBus.$on("SHOW_CONFERENCE_CHANNEL", (channel_id) => {
            this.CallChannel = SessionManager.getChannel(channel_id)
        })

        serverBus.$on("SOCKET_DISABLE_AUDIO", (data) => {
            //   if(SessionManager.getLoggedInUserId() != data.creator_user_id){
            let audioElement = document.getElementById("audio_from_" + data.creator_user_id)
            if (data.disabled) {
                this.mutedAudioUsersIds.push(data.creator_user_id)
            } else {
                this.mutedAudioUsersIds.splice(this.mutedAudioUsersIds.indexOf(data.creator_user_id), 1)
            }
            if (audioElement) {
                audioElement.srcObject.getAudioTracks()[0].enabled = !data.disabled
            }
            //   }
        })

        // serverBus.$on("SOCKET_DECLINE_CALL", (data) => {
        //     if(SessionManager.getLoggedInUserId() != data.creator_user_id){
        //         Global.globalValue("SHOW_CONFERENCE", false)
        //     }
        // })

        serverBus.$on("SOCKET_DISABLE_VIDEO", (data) => {
            if (data.disabled && this.videoUsersIds.indexOf(data.creator_user_id) > -1) {
                this.videoUsersIds.splice(this.videoUsersIds.indexOf(data.creator_user_id), 1)
                if (document.getElementById("video_from_" + data.creator_user_id) != null) {
                    document.getElementById("video_from_" + data.creator_user_id).outerHTML = ""
                }
            }
            // let videoElement = document.getElementById("video_from_" + data.creator_user_id)
            // if(videoElement  != null && typeof videoElement.srcObject.getVideoTracks()[0] != 'undefined'){
            //     videoElement.srcObject.getVideoTracks()[0].enabled = !data.disabled
            //     videoElement.srcObject.getVideoTracks()[0].stop()
            // }
        })

        serverBus.$on("SHOW_CONFERENCE", (value) => {
            this.showConference = value
            if (!value) {
                this.ResetData()
            }
        })

        serverBus.$on("CLEAN_REMOVE_USER", (data) => {
            if (data.creator_user_id != SessionManager.getLoggedInUserId()) {
                Global.globalValue("CALL_REMOVE_USER", data.remove_user_id)
            }
        })


        serverBus.$on("CALL_REMOVE_USER", (user_id) => {
            if (user_id == SessionManager.getLoggedInUserId()) {
                this.ConferenceUsers = []
                this.showConference = false
            }

            if (this.loggedInUser.user_id != user_id && this.inCall) {
                Global.globalValue("rtc_call_banner_message_green", this.GetUser(user_id).username + " has left the call")
            }

            for (let i = 0; i < this.ConferenceUsers.length; i++) {
                if (this.ConferenceUsers[i].user_id == user_id) {
                    this.ConferenceUsers.splice(i, 1)
                    console.log("removed user " + this.GetUser(user_id).username)
                    break
                }
            }
        })


        serverBus.$on("CALL_GOT_USER_STATES_DECLINE", (user_id) => {
            let currDecUser = this.GetUser(user_id)
            if (!this.Declined.some(currUser => {
                    return currUser.user_id == currDecUser.user_id
                })) {
                this.Declined.push(this.GetUser(currDecUser.user_id))
            }

            for (let j = 0; j < this.ConferenceUsers.length; j++) {
                if (currDecUser.user_id == this.ConferenceUsers[j].user_id) {
                    this.ConferenceUsers.splice(j, 1)
                    break
                }
            }
        })

        serverBus.$on("CALL_GOT_USER_STATES", (data) => {
            let currUser;
            if (typeof data.timed_out_user_ids != "undefined" && data.timed_out_user_ids) {
                for (let i = 0; i < data.timed_out_user_ids.length; i++) {
                    currUser = this.GetUser(data.timed_out_user_ids[i])
                    for (let j = 0; j < this.ConferenceUsers.length; j++) {
                        if (currUser.user_id == this.ConferenceUsers[j].user_id) {
                            this.ConferenceUsers.splice(j, 1)
                            break
                        }
                    }

                    if (!this.ConferenceUsers.some(currUser => {
                            return currUser.callstate == "ringing"
                        }))
                        this.showRinging = false
                    if (currUser.reachability == "online")
                        this.NotReacted.push(currUser)
                }
                return
            }

            if (typeof data.avaliable_user_ids != "undefined") {
                for (let i = 0; i < data.avaliable_user_ids.length; i++) {
                    if (!this.ConferenceUsers.some(currUser => {
                            return currUser.user_id == data.avaliable_user_ids[i]
                        })) {
                        currUser = this.GetUser(data.avaliable_user_ids[i])
                        currUser.callstate = "ringing"
                        if (currUser.reachability == "online")
                            this.ConferenceUsers.push(currUser)
                    }
                }
            }

            if (typeof data.busy_user_ids != "undefined") {
                for (let i = 0; i < data.busy_user_ids.length; i++) {
                    if (!this.BusyUsers.some(currUser => {
                            return currUser.user_id == data.busy_user_ids[i]
                        })) {
                        this.BusyUsers.push(this.GetUser(data.busy_user_ids[i]))
                    }
                }
            }
        })

        serverBus.$on("CALL_GOT_USER", (data) => {
            if (data.streamEvent == null) {
                return
            }

            if (typeof data.streamEvent.track == 'undefined') {
                data.streamEvent.track = data.streamEvent.getTracks()[0]
                data.streamEvent.streams = [data.streamEvent]
            }


            let currUser = this.GetUser(data.user_id)
            currUser.callstate = "accepted"

            if (!this.ConferenceUsers.some(currUser => {
                    return currUser.user_id == data.user_id
                })) {
                this.ConferenceUsers.push(currUser)
            } else {
                for (let i = 0; i < this.ConferenceUsers.length; i++) {
                    if (this.ConferenceUsers[i].user_id == currUser.user_id) {
                        this.ConferenceUsers[i].callstate = "accepted"
                        break
                    }
                }
            }


            for (let j = 0; j < this.Declined.length; j++) {
                if (currUser.user_id == this.Declined[j].user_id) {
                    this.Declined.splice(j, 1)
                    break
                }
            }

            this.ConferenceUsers.sort((a, b) => {
                if (b.callstate == "accepted" && a.callstate != "accepted") {
                    return 1
                }
                return -1
            })
            // alert(this.ConferenceUsers.some(currUser => {return currUser.user_id == data.user_id}))
            if (!this.ConferenceUsers.some(currUser => {
                    return currUser.callstate == "ringing"
                }))
                this.showRinging = false

            let conferenceElement = document.getElementById("conference_" + data.user_id)

            if (data.streamEvent.track.kind == "audio") {

                var audioCtx = new(window.AudioContext || window.webkitAudioContext)();
                var source = audioCtx.createMediaStreamSource(data.streamEvent.streams[0])
                //source.context.destination

                let soundMeter = new SoundMeter(source.context);
                soundMeter.connectToSource(data.streamEvent.streams[0], function(e) {
                    if (e) {
                        console.log(e);
                        return;
                    }
                    // if(data.user_id != this.loggedInUser.user_id){
                    setInterval(() => {

                        if (document.getElementById('volume_' + data.user_id) != null) {
                            document.getElementById('volume_' + data.user_id).style.backgroundSize = soundMeter.instant * 500 + "%"
                        }
                        // console.log(soundMeter.instant.toFixed(2)*100)
                        //   instantMeter.value = instantValueDisplay.innerText =
                        //     soundMeter.instant.toFixed(2);
                        //   slowMeter.value = slowValueDisplay.innerText =
                        //     soundMeter.slow.toFixed(2);
                        //   clipMeter.value = clipValueDisplay.innerText =
                        //     soundMeter.clip;
                    }, 200);
                    // }
                });




                console.log("********audio log**********")
                console.log("got audio user " + this.GetUser(data.user_id).username)
                if (this.loggedInUser.user_id != data.user_id && this.inCall) {
                    Global.globalValue("rtc_call_banner_message_green", this.GetUser(data.user_id).username + " has joined the call")
                }
                if (document.getElementById("audio_from_" + data.user_id) == null) {
                    let audioElem = document.createElement("audio")
                    audioElem.id = "audio_from_" + data.user_id
                    audioElem.autoplay = true
                    audioElem.controls = true
                    audioElem.srcObject = data.streamEvent.streams[0]

                    // mute my audio sound
                    if (data.user_id == SessionManager.getLoggedInUserId()) {
                        audioElem.muted = true
                    }

                    if (conferenceElement != null) {
                        conferenceElement.appendChild(audioElem)
                    } else {
                        document.body.appendChild(audioElem)
                    }
                } else {
                    if (document.getElementById("audio_from_" + data.user_id).srcObject != data.streamEvent.streams[0]) {
                        document.getElementById("audio_from_" + data.user_id).srcObject = data.streamEvent.streams[0]
                    }
                }
            }


            if (data.streamEvent.track.kind == "video") {
                if (!this.videoUsersIds.some(currUser => {
                        return currUser.user_id == data.user_id
                    })) {
                    this.videoUsersIds.push(data.user_id)
                }
                if (document.getElementById("video_from_" + data.user_id) == null) { //  || true
                    console.log("got video user " + this.GetUser(data.user_id).username)
                    console.log("i got ", data.streamEvent.streams[0])
                    let videoElem = document.createElement("video")
                    videoElem.id = "video_from_" + data.user_id
                    videoElem.autoplay = true
                    videoElem.muted = true
                    videoElem.playsinline = true
                    videoElem.loop = true
                    videoElem.srcObject = data.streamEvent.streams[0]

                    if (conferenceElement != null) {
                        conferenceElement.appendChild(videoElem)
                    } else {
                        // document.body.appendChild(videoElem)
                        //@TODO better approach instead of time
                        setTimeout(function() {
                            conferenceElement = document.getElementById("conference_" + data.user_id)
                            conferenceElement.appendChild(videoElem)
                        }, 4000)
                    }
                } else {
                    if (document.getElementById("video_from_" + data.user_id).srcObject != data.streamEvent.streams[0]) {
                        document.getElementById("video_from_" + data.user_id).srcObject = data.streamEvent.streams[0]
                    }
                }
            }

        })
    },
    methods: {
        GetUser(user_id) {
            return SessionManager.getUser(user_id)
        },
        setActiveVideo(user_id) {
            this.ConferenceUsers.sort((a, b) => {
                if (b.user_id == user_id) {
                    return 1
                }
                return -1
            })
        },
        fullScreenVideo(user_id) {
            if (!this.isFullscreen) {
                this.originalParentNode = this.$el.parentNode;
                this.originalNode = this.$el
                document.body.appendChild(this.originalNode)
                this.isFullscreen = true
            } else {
                this.isFullscreen = false
                this.originalParentNode.appendChild(this.originalNode)
            }
        },
        muteUser(user_id) {
            let audioSrc = document.getElementById("audio_from_" + user_id)
            if (audioSrc) {
                audioSrc.muted = !audioSrc.muted
            }
            if (this.mutedAudioUsersIds.indexOf(user_id) < 0) {
                this.mutedAudioUsersIds.push(user_id)
            } else {
                this.mutedAudioUsersIds.splice(this.mutedAudioUsersIds.indexOf(user_id), 1)
            }
        },
        DeclineUser(user_id) {
            Global.globalValue("DECLINE_USER_ID", user_id)
        },
        ResetData() {
            this.ConferenceUsers = []
            this.BusyUsers = []
            this.NotReacted = []
            this.Declined = []
            this.showConference = false
            this.videoUsersIds = []
            this.mutedAudioUsersIds = []
            this.right_sidebar_theme = ''
            this.mouseOverUserId = ''
            this.showRinging = true
        }
    }
}
